import {TableCell} from '@tiptap/extension-table-cell';

function hex8ToRgba(hex) {
    if (!/^#([0-9a-f]{8})$/i.test(hex)) return hex
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)
    const a = parseInt(hex.slice(7, 9), 16) / 255
    return `rgba(${r}, ${g}, ${b}, ${a})`
}

export const TableCellCustom = TableCell.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            backgroundColor: {
                default: null,
                renderHTML: (attributes) => {
                    let color = attributes.backgroundColor
                    if (!color || typeof color !== 'string') return {}
                    color = hex8ToRgba(color)
                    return {
                        style: `background-color: ${color}`,
                    }
                },
                parseHTML: (element) => {
                    const style = element.style.backgroundColor
                    if (!style) return null

                    return style
                },
            },
        }
    },
})
